import Swal from 'sweetalert2';

// Aviso común para un 403 del API (middleware rol o coopconfig). Lo usan los
// interceptores de axios (http-common*) y Api.fetch (app-controller.js).
export function avisarSinPermiso(message) {
  Swal.fire({
    title: 'Sin permiso',
    text: typeof message === 'string' && message !== '' ? message : 'No tienes permiso para esta acción.',
    icon: 'warning',
    confirmButtonText: 'Ok',
  });
}

export function interceptarSinPermiso(http) {
  http.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 403) {
        avisarSinPermiso(error.response.data?.message);
      }
      return Promise.reject(error);
    }
  );
  return http;
}
